import { render, staticRenderFns } from "./kaijiang.vue?vue&type=template&id=4b8f666a&scoped=true"
import script from "./kaijiang.vue?vue&type=script&lang=js"
export * from "./kaijiang.vue?vue&type=script&lang=js"
import style0 from "./kaijiang.vue?vue&type=style&index=0&id=4b8f666a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f666a",
  null
  
)

export default component.exports